import '../../css/searchPage.css'
import { Box } from "@mui/system";
import { TextPrimary } from "../typography";


const FilterButton = ({ text, onClick, borderBool, badge }: { text: string, onClick: any, borderBool: boolean, badge: any }) => {
    return (
        <Box sx={{ backgroundColor: '#FFFEF9', borderRadius: '5px', py: '6px', px: 1, border: borderBool ? '1px solid #FE702D' : 'none', display: 'flex', gap: '4px' }} onClick={onClick}>
            <TextPrimary color='#000' text={text} />
            <TextPrimary color='#FE702D' text={badge > 0 ? `(` + badge + `)` : ''} />
        </Box>
    )
};

export default FilterButton;